type N = number | null | undefined;

export const fmtNum = (n: N): string => (n === null || n === undefined ? '—' : Number(n).toLocaleString('pt-BR', { maximumFractionDigits: 0 }));

export const fmtMoney = (n: N): string => (n === null || n === undefined ? '—'
  : Number(n).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 }));

export const fmtMoney2 = (n: N): string => (n === null || n === undefined ? '—'
  : Number(n).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }));

export const fmtPct = (n: N, d = 1): string => (n === null || n === undefined ? '—'
  : (Number(n) * 100).toLocaleString('pt-BR', { minimumFractionDigits: d, maximumFractionDigits: d }) + '%');

export const fmtPp = (n: N): string => (n === null || n === undefined ? '—'
  : (n > 0 ? '+' : '') + (Number(n) * 100).toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' p.p.');

export const fmtData = (iso: string | null | undefined): string => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : '—');
export const fmtDataCurta = (iso: string | null | undefined): string => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}` : '—');
export const fmtDataHora = (iso: string | null | undefined): string => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)} ${iso.slice(11, 16)}` : '—');

export const fmtDias = (horas: N): string => {
  if (horas === null || horas === undefined) return '—';
  const d = Number(horas) / 24;
  const s = d.toLocaleString('pt-BR', { maximumFractionDigits: 1 });
  return `${s} ${s === '1' ? 'dia' : 'dias'}`;
};

// Export CSV (no lugar do XLSX gerado pelo backend — SDD §6)
export function downloadCsv(nomeArquivo: string, colunas: string[], linhas: (string | number | null | undefined)[][]) {
  const esc = (v: string | number | null | undefined): string => {
    const s = v === null || v === undefined ? '' : String(v);
    return /[";\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const csv = [colunas.map(esc).join(';'), ...linhas.map((l) => l.map(esc).join(';'))].join('\n');
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nomeArquivo;
  a.click();
  URL.revokeObjectURL(url);
}
